import { ActionButtonProps, Box, Button, Form, Text } from '@jfs/ui-new'
import { useIsFocused, useNavigation } from '@react-navigation/native'
import { FC, ReactElement, useEffect, useRef, useState } from 'react'
import { InteractionManager, TextInput as RNTextInput } from 'react-native'
import { DefaultFormContainer } from '../../comps/DefaultFormContainer'
import { SvgImage } from '../../comps/SvgImage'
import { loginStrings } from '../../data/static/strings'
import { useLazyApiData, useStores } from '../../data/store'
import { Routes } from '../../nav/routes'
import { logEvent, storeData, testProps } from '../../util/util'
import { formData } from './FormDataForMobile'
import { styles } from './styles'

interface ForgotpasswordProps {
  hide?: boolean
  onPress?: any
}

const ForgotPasswordMobile: FC<ForgotpasswordProps> = ({ hide, onPress }: ForgotpasswordProps) => {
  const isMobileDevice = true //because it is index.native file

  const { userObj, mobileNum, updateMobile, selectedAppLanguage } = useStores((root) => ({
    userObj: root.user.generateOtp,
    mobileNum: root.settings.metaData.mobileNumber,
    updateMobile: root.settings.metaData.updateMobileNumber,
    selectedAppLanguage: root.settings.config.selectedAppLanguage,
  }))
  const passwordRef = useRef<RNTextInput>(null)
  const [isLoading, setIsLoading] = useState(false)
  const [generateOtp, { state }] = useLazyApiData(userObj)
  const navigation = useNavigation()
  const isFocussed = useIsFocused()

  useEffect(() => {
    if (isFocussed) {
      setIsLoading(false)
      InteractionManager.runAfterInteractions(() => {
        if (passwordRef?.current) {
          // 'focus input'
          passwordRef?.current?.focus()
        }
      })
    }
  }, [isFocussed])

  useEffect(() => {
    if (state === 'fulfilled') {
      navigation?.navigate(
        Routes.OTP as never,
        {
          path: Routes.OTP,
          isSignUp: false,
          mobileNum: mobileNum,
          isFromForgotPwd: true,
        } as never,
      )
    } else if (state === 'rejected') {
      setIsLoading(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state])

  if (hide) {
    return null
  }

  const renderActionButtons = ({
    defaultActionButtonOnSubmit,
    values,
    isValid,
    title,
  }: ActionButtonProps): ReactElement => {
    const handleResetPress = (): void => {
      defaultActionButtonOnSubmit()
      updateMobile(values?.mobileNumber)
      storeData(loginStrings.userMobileNumber, values.mobileNumber)
      if (values?.mobileNumber?.length === 10 || isValid) {
        setIsLoading(true)
        logEvent('btn_press', 'generate_otp')
        generateOtp(values.mobileNumber)
      }
    }
    return (
      <Box {...styles.buttonContainer} paddingBottom={16}>
        <Button
          isFull
          isRound
          isLoading={isLoading}
          height={48}
          color={'PRIMARY'}
          {...testProps('send-otp-button')}
          onPress={handleResetPress}>
          <Text color={'WHITE'} fontFamily={'JioType-Bold'} fontSize={16} letterSpacing={-0.08}>
            {title}
          </Text>
        </Button>
      </Box>
    )
  }

  const leftComp = <Text title={'+91'} fontFamily={'JioType-Medium'} fontSize={24} lineHeight={32} color={'BLACK_21'} />
  return (
    <Box f={1} align={'center'} justify={'space-between'} bg={'SECONDARY'}>
      <Box w={'100%'} h={64} ph={16} align={'flex-start'} justify={'center'}>
        <Box
          underlayColor="TRANSPARENT"
          testID="arrow-left"
          onPress={() => [navigation.navigate('signin' as never), onPress()]}>
          <SvgImage imageName="HeaderArrowLeft" />
        </Box>
      </Box>
      <Box w={'100%'} f={1}>
        <Box {...styles.cardContainer} marginTop={0} f={1}>
          <Box
            {...styles.card}
            borderBottomLeftRadius={0}
            borderBottomRightRadius={0}
            borderTopLeftRadius={24}
            flexGrow={1}
            paddingHorizontal={24}
            paddingTop={32}
            borderTopRightRadius={24}>
            <Box {...styles.formContainer(isMobileDevice)}>
              <Form
                container={DefaultFormContainer}
                formData={formData(selectedAppLanguage, leftComp, passwordRef)}
                actionButtons={renderActionButtons}
                initialValues={{ mobileNumber: mobileNum }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default ForgotPasswordMobile
